<template>
	<div id="app">
        <router-view></router-view>
	</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'App',
	created(){
		
	}
}
</script>

<style>
html,body{height:100%;overflow:hidden}
#app {
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	position: absolute;
	left:0;top:0;right:0;bottom:0;
	overflow: hidden;
    background:#F2F2F2;
    min-width:1200px;
}
.loading{
    position: absolute;
    left:0;top:0;right:0;bottom:0;
    z-index:10000000;
    transition: all .2s;
    opacity: 0;
}
.loading-area{
    position: absolute;
    width:200px;
    height:80px;
    background:url('/admin/static/layer/theme/default/loading-0.gif') center center no-repeat;
    background-color:rgba(0,0,0,.7);
    border-radius:10px;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue